module.exports = __webpack_public_path__ + "static/media/login-button.a7ea9f33.png";